import React from 'react'
import { Grid, IconButton, Tooltip } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useHookstate } from '@hookstate/core'
import DispatchClosedDialog from '~/features/Dispatch/components/DispatchClosedButton/components/DispatchClosedDialog'
import { useLang } from '~/hooks/useLang'

interface DispatchClosedButtonProps {
  readonly canClose: boolean | undefined
  readonly closeDispatch: (params: any) => Promise<boolean> | undefined
}

export default function DispatchClosedButton(props: DispatchClosedButtonProps) {
  const open = useHookstate(false)
  const { translate } = useLang()

  return (
    <Grid item>
      <Tooltip
        title={translate('Fechar Despacho')}
        placement="right-start"
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton disabled={!props.canClose} onClick={() => open.set(true)}>
            <Close />
          </IconButton>
        </span>
      </Tooltip>
      {open.get() && (
        <DispatchClosedDialog open={open} closeDispatch={props.closeDispatch} />
      )}
    </Grid>
  )
}
